import { Layout, List, Modal } from 'antd';

import React, { useEffect, useState } from 'react';
import Icofont from 'react-icofont';
import { useDispatch, useSelector } from 'react-redux';
import {
	NavLink,
	Route,
	Routes,
	useNavigate
} from "react-router-dom";
import REDUX_UserConfig from '../../../objects/UserConfig/reducer'
import REDUX_Translate from '../../../objects/Translate/reducer';
import { GETWITH, LanguageContext, MetaContext, POST, publish, QueryOrder, QueryParam, subscribe, TranslateContext, unsubscribe, useAuth, UserConfigContext, UserContext, useTranslateContext } from 'fennec-ui';
import CRUDE_Pari from '../../../objects/Pari/crude';
import REDUX_Pari from '../../../objects/Pari/reducer';
import CRUDE_VseTipiPolzovatelei from '../../../objects/VseTipiPolzovatelei/crude';
import REDUX_AkkauntiPolzovatelei from '../../../objects/AkkauntiPolzovatelei/reducer';
import { errorCatch, QueryDetail, READWITH } from 'fennec-ui';
import SiteAccessDeny from '../SiteAccessDeny';
import './index.css';
import { access, defaultRoute, translate } from '../../../common/Tool';
import Common from '../Common';
import Federationadministrator from '../Federationadministrator';
import Localadmin from '../Localadmin';
import School from '../School';
import Organizer from '../Organizer';
import Admin from '../Admin';
import AdminMainResourceLocks from '../AdminMainResourceLocks';

import FedHeader from '../FedHeader'
import { BreadcrumbsProvider, LangSwitchContext, MenuLevelOneContext, useIsDesktopOrLaptopContext, useIsMobileContext, useLayoutWidthContext } from '../../../common/Context';
import EventsAdmin from '../EventsAdmin';
import Kurator from '../Kurator';
import Promouter from '../Promouter';
import Artist from '../Artist';
import ContextRoute, { ContextConfig, ContextList } from '../ContextRoute';
import { ContextAutomationElement, ContextGetpromoElement, ContextLocaladminElement, ContextOrganizerElement, ContextSchoolElement, ContextTeacherElement, ContextTestingElement } from '../../components/ContextElement';
import Testing from '../Testing';
import Automation from '../Automation';
import Promo from '../Promo';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import Error404 from '../../components/Error404';
import Teacher from '../Teacher';
import Music from '../Music';
import PostsCreator from '../PostsCreator';
import LangSwitch from '../../components/LangSwitch';
var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

var _ = require('lodash');

const { Content, Footer } = Layout;
const { confirm } = Modal;

function MenuOne({ menu }) {
	const t = useTranslateContext();
	const role_by_id = useSelector(state => state.home.role_by_id);

	if (menu.length <= 0) return (<></>);
	const elements = menu.map((e, index) => {
		const key = e.uuid || e.key || index;
		if (e.hidden || e.unvisible) {
			return
		}
		if (e.component && access(e, role_by_id)) {
			return (
				<div key={key} className="nav-header">
					<NavLink className="nav-header-link" to={key}>
						{(pax) =>
							<div className="nav-header-link-fn">

								<div className={`nav-header-title${(pax.isActive) ? " selected" : ""}${(e?.light) ? " light" : ""}`}>
									<div className="dot-wrapper">
										<div className='dot' style={(e?.color) ? { background: e?.color } : {}}></div>
									</div>
									<div className='nav-header-content'>
										{e.name}
									</div>
									<div className='nav-header-extend'>
										{e?.extend}
									</div>
								</div>
							</div>
						}
					</NavLink>
				</div>
			)
		}
	})
	return (
		<List
			header={<span style={{ fontSize: "11px" }}>{t("Доступные роли")}</span>}
		>
			{elements}
		</List>
	)
}

function Home(props) {
	const menu = (status, notify) => {
		const x = [
			{
				uuid: "common",
				default: true,
				name: "Пользователь",
				color: "#dee2e6",
				component: (props) => (<Common {...props} />),
				role: [
					{ "ID": 4, "nazvanie": "ОбычныйПользователь" },
				],
			},
			{
				uuid: "federation-administrator",
				name: "Федерация",
				color: "#8b8ddd",// "#ffc8dd",
				component: (props) => (<Federationadministrator {...props} />),
				role: [
					{ "ID": 5, "nazvanie": "ПрезидентФедерации" },
					{ "ID": 8, "nazvanie": "АдминистраторКонференции" },
					{ "ID": 9, "nazvanie": "АдминистраторФедерации" },
				],
			},
			{
				uuid: "local",
				name: "Региональное отделение",
				color: "#02c0cb",
				component: (props) => (
					<ContextRoute uuid=":id"
						display={(item) => <ContextLocaladminElement item={item} color={"#02c0cb"} />}
						displayString={(item) => item?.nazvanie}
						params={[
							QueryOrder("nazvanie", "ASC")
						]}
						listSource="/api/ro/list-by-admin"
						list={<ContextList {...props} />}

						itemSource="/api/ro/list-by-admin"
						item={<Localadmin {...props} />}

					// configSource="/api/ro/list-by-admin"
					// config={<ContextConfig {...props} />}

					/>),
				role: [
					{ "ID": 14, "nazvanie": "АдминистраторОбщегоСобрания" },
					{ "ID": 15, "nazvanie": "АдминистраторОтделения" },
					{ "ID": 29, "nazvanie": "АдминистраторМероприятийРО" },
				],
			},
			{
				uuid: "school",
				name: "Школа",
				color: "#eae2b7",
				component: (props) => (
					<ContextRoute uuid=":id"
						display={(item) => <ContextSchoolElement item={item} color={"#eae2b7"} />}
						displayString={(item) => item?.nazvanieShkoliTantsev}
						params={[
							QueryOrder("nazvanieShkoliTantsev", "ASC")
						]}
						listSource="/api/school/list-by-admin"
						list={<ContextList {...props} />}

						itemSource="/api/school/list-by-admin"
						item={<School {...props} />}
					/>),
				role: [
					{ "ID": 18, "nazvanie": "ВладелецШколыФедерации" },
					{ "ID": 19, "nazvanie": "АдминистраторШколыФедерации" },
					{ "ID": 20, "nazvanie": "АдминистраторКоллективаФедерации" },
				],
			},
			{
				uuid: "organizer",
				name: "Организатор",
				color: "#a2d2ff",
				component: (props) => (
					<ContextRoute uuid=":id"
						display={(item) => <ContextOrganizerElement item={item} color={"#a2d2ff"} />}
						displayString={(item) => item?.nazvanie}
						params={[
							QueryOrder("nazvanie", "ASC")
						]}
						listSource="/api/org/list-by-admin"
						list={<ContextList {...props} />}

						itemSource="/api/org/list-by-admin"
						item={<Organizer {...props} />}

					// configSource="/api/org/list-by-admin"
					// config={<ContextConfig
					// 	{...props}
					// 	ContextObject={{
					// 		tipPolzovatelyaID: 23,
					// 		polzovatelID: user?.ID
					// 	}}
					// 	Fields={[
					// 		{ label: "Дополнительная информация", name: "EXT_TEXT", type: "text" },
					// 	]}
					// 	title={(<div>
					// 		<div>Установка дополнительных параметров</div>
					// 		<div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>для всех объектов "Организатор федерации"</div>
					// 	</div>)} />}
					/>),
				role: [
					{ "ID": 23, "nazvanie": "ОрганизаторФедерации" },
					{ "ID": 25, "nazvanie": "АдминистраторОрганизатораФедерации" }
				],
			},
			{
				uuid: "teacher",
				name: "Преподаватель",
				color: "#FF9933",
				component: (props) => (
					<ContextRoute uuid=":id"
						display={(item) => <ContextTeacherElement item={item} color={"#FF9933"} />}
						displayString={(item) => item?.regionalnoeOtdelenie?.nazvanie}

						listSource="/api/prepodavateli-federatsii/list-by-admin"
						list={<ContextList {...props}
							queryDetail={"model"}
							params={[
								QueryOrder("user.lastname", "ASC"),
								QueryOrder("user.firstname", "ASC"),
								QueryOrder("regionalnoeOtdelenie.nazvanie", "ASC"),
							]}
							title={<div style={{ padding: "10px 7px", fontSize: "16px" }}>Выберите одно из региональных отделений, в котором вы зарегистрированы </div>}
							empty={<div>Нет доступных региональных отделений</div>}
						/>}

						itemSource="/api/prepodavateli-federatsii/list-by-admin"
						item={<Teacher {...props}
							params={[
								QueryOrder("user.lastname", "ASC"),
								QueryOrder("user.firstname", "ASC"),
								QueryOrder("regionalnoeOtdelenie.nazvanie", "ASC"),
								QueryDetail("model"),
							]} />}
					/>),
				role: [
					{ "ID": 21, "nazvanie": "ПреподавательФедерации" }
				],
			},
			{
				uuid: "admin",
				name: "Админ",
				color: "#718355",
				component: (props) => (<Admin {...props} />),
				role: [
					{ "ID": 28, "nazvanie": "СуперАдмин" },
				],
			},
			{
				uuid: "events-admin",
				name: "Администратор мероприятия",
				color: "#ffc8dd",
				component: (props) => (<EventsAdmin {...props} auth={auth} />),
				role: [
					{ "ID": 30, "nazvanie": "АдминистраторМероприятия" },
				]
			},
			{
				uuid: "kurator",
				name: "Куратор",
				color: "#f058dd",
				component: (props) => (<Kurator {...props} auth={auth} />),
				role: [
					{ "ID": 33, "nazvanie": "Куратор" },
				]
			},
			{
				uuid: "promouter",
				name: "Промоутер",
				color: "#2a9d8f",
				component: (props) => (<Promouter {...props} auth={auth} />),
				role: [
					{ "ID": 34, "nazvanie": "Промоутер" },
				]
			},
			{
				uuid: "posts",
				name: "Создатель постов",
				color: "#203d1f",
				component: (props) => (<PostsCreator {...props} auth={auth} />),
				role: [
					{ "ID": 5, "nazvanie": "ПрезидентФедерации" },
					{ "ID": 9, "nazvanie": "АдминистраторФедерации" },
					{ "ID": 38, "nazvanie": "СоздательПостов" },
				]
			},
			{
				uuid: "getpromo",
				name: "Получение промокода",
				unvisible: true,
				color: "#FF7900", // #3B3C36
				component: (props) => (
					<ContextRoute uuid=":id"
						display={(item) => <ContextGetpromoElement item={item} color={"#FF7900"} />}
						displayString={(item) => item?.nazvanieMeropriyatiya
						}
						params={[
							QueryParam("w-eq-promokodiMeropriyatie.shablonniiPromokod", "true"),
							QueryParam("w-eq-isPublic", "true"),
							QueryOrder("nachaloSorevnovaniya", "DESC"),
							QueryParam("w-lge-okonchanieSorevnovaniya", dayjs().format("YYYY-MM-DD")),
							QueryDetail("model")
						]}
						listSource="/api/meropriyatiya/list/com"
						list={<ContextList
							{...props}
							title={<div style={{ padding: "10px 7px", fontSize: "16px" }}>Выберите мероприятие по которому хотите получить промокод</div>}
							empty={<div>Нет доступных мероприятий</div>}
						/>}

						itemSource="/api/meropriyatiya/list/com"
						item={<Promo {...props} />}

					/>),
				role: [
					{ "ID": 4, "nazvanie": "ОбычныйПользователь" },
				]
			},
			{
				uuid: "artist",
				name: "Артист",
				color: "#ccd5ae",
				component: (props) => (<Artist {...props} auth={auth} />),
				role: [
					{ "ID": 35, "nazvanie": "Артист" },
				]
			},
			{
				uuid: "testing",
				name: "Судейская аттестация",
				unvisible: true,
				color: "#738678",
				component: (props) => (
					<ContextRoute uuid=":id"
						display={(item) => <ContextTestingElement item={item} color={"#738678"} />}
						displayString={(item) => item?.kategoriyaSudeistva?.nazvanieKategorii + " - " + item?.kategoriyaSudeistva?.tanets?.nazvanie}
						params={[
							QueryOrder("kategoriyaSudeistva.nazvanieKategorii", "ASC"),
							QueryOrder("kategoriyaSudeistva.tanets.nazvanie", "ASC"),
							QueryDetail("model")
						]}
						listSource="/api/testisudeiskikhattestatsii/listbysudya"
						list={<ContextList {...props} params={[
							QueryOrder("kategoriyaSudeistva.nazvanieKategorii", "ASC"),
							QueryOrder("kategoriyaSudeistva.tanets.nazvanie", "ASC"),
							QueryDetail("collection")
						]} />}

						itemSource="/api/testisudeiskikhattestatsii/listbysudya"
						item={<Testing {...props} />}
					/>),
				role: [
					{ "ID": 4, "nazvanie": "ОбычныйПользователь" },
				],
			},
			{
				uuid: "automation",
				name: "Автоматизация",
				unvisible: true,
				color: "#007aa5",
				component: (props) => (
					<ContextRoute uuid=":id"
						display={(item) => <ContextAutomationElement item={item} color={"#007aa5"} />}
						displayString={(item) => item?.name}
						params={[
							QueryOrder("name", "ASC")
						]}
						listSource="/api/query/fsmcontext"
						list={<ContextList {...props} />}

						itemSource="/api/query/fsmcontext"
						item={<Automation {...props} />}
					/>),
				role: [
					{ "ID": 4, "nazvanie": "ОбычныйПользователь" },
				],
			},
			{
				uuid: "music",
				name: "Музыка",
				color: "#334ac0",
				component: (props) => (<Music {...props} />),
				role: [
					{ "ID": 5, "nazvanie": "ПрезидентФедерации" },
					{ "ID": 9, "nazvanie": "АдминистраторФедерации" },
				],
			},
			{
				uuid: "*",
				name: "Error404",
				unvisible: true,
				component: (props) => (
					<Error404 />),
				role: [
					{ "ID": 4, "nazvanie": "ОбычныйПользователь" },
				],
			}
		]
		return x
	};

	let navigate = useNavigate();
	const auth = useAuth();
	const dispatch = useDispatch();
	const userConfig = useSelector(REDUX_UserConfig.selector.object) || {};
	const translates = useSelector(REDUX_Translate.selector.object);
	const [language, setLanguage] = useState({ lang: (auth.getCookie("lang") || "ru") })
	const t = React.useMemo(() => _.bind(translate, {
		translate: translates,
		config: language
	}), [translates, language]);
	// const t = useTranslateContext();
	// console.log(t("да"));

	const setUserConfig = (name, value, onChange) => {
		POST(auth, "/api/setuserconfig", {
			key: name,
			value: value
		}, ({ data }) => {
			var arr = [data];
			var obj = Object.fromEntries(arr.map(i => {
				return [
					i.key,
					i.value
				]
			}));
			let i = { ...userConfig, ...obj };
			let o = REDUX_UserConfig.actions.setObject(i);
			dispatch(o);
			if (onChange) {
				onChange(i);
			}
		}, errorCatch);
	};

	const siteAccess = useSelector(state => state.siteAccess.value);
	//-------------------------------------------------------------
	const [layout, setLayout] = useState("web"); // app | web
	const [fullwidth, setFullwidth] = useState(false);
	//-------------------------------------------------------------

	const meta = useSelector(state => state.meta);
	const user = useSelector(state => state.home.user);
	const role_by_id = useSelector(state => state.home.role_by_id);
	const status = useSelector(state => state.home.status, () => { }); // Статусы
	const notify = useSelector(state => state.home.notify, () => { }); // Уведомления

	//-------------------------------------------------------------------------------
	useEffect(() => {
		_subscribe();
		return () => {
			_unsubscribe();
		};
	}, []);
	//-------------------------------------------------------------------------------

	const uuid = "8112134771fa";
	useEffect(() => {
		let token = subscribe("service.status", function (msg, data) {
			if (msg.startsWith(`service.status.${uuid}`)) {
				return
			}
			dispatch({ type: 'STATUS-UPDATE', payload: data })
		});
		return () => {
			unsubscribe(token);
		};
	}, [])
	useEffect(() => {
		let token = subscribe("service.status.clear", function (msg, data) {
			dispatch({ type: 'STATUS', payload: [] })
		});
		return () => {
			unsubscribe(token);
		};
	}, [])
	useEffect(() => {
		let token = subscribe("service.notify", function (msg, data) {
			if (msg.startsWith(`service.notify.${uuid}`)) {
				return
			}
			dispatch({ type: 'NOTIFY-UPDATE', payload: data })
		});
		return () => {
			unsubscribe(token);
		};
	}, [])
	useEffect(() => {
		let token = subscribe("service.notify.clear", function (msg, data) {
			dispatch({ type: 'NOTIFY', payload: [] })
		});
		return () => {
			unsubscribe(token);
		};
	}, [])
	const _subscribe = () => {
		auth.fetch('/api/meta').then(res => {
			if (res && res.data && dispatch) {
				dispatch({ type: 'META', payload: res.data })
			}
		});
		auth.fetch('/api/iam').then(res => {
			if (res && res.data) {
				dispatch({ type: 'USER', payload: res.data })
			}
		});
		READWITH(auth, 'Translate', [
			QueryDetail("model")
		], ({ data }) => {
			if (data.length > 0) {
				let o = Object.fromEntries(data.map(i => {
					return [
						i.key,
						{
							ru: i.ru,
							en: i.en,
							es: i.es,
							tr: i.tr,
						},
					]
				}));
				dispatch(REDUX_Translate.actions.setObject(o));
			}
		}, errorCatch)
		READWITH(auth, 'UserConfig', [
			QueryDetail("model")
		], ({ data }) => {
			if (data.length > 0) {
				var obj = Object.fromEntries(data.map(i => {
					return [
						i.key,
						i.value
					]
				}));
				dispatch(REDUX_UserConfig.actions.setObject(obj));
			}
		}, errorCatch)
		CRUDE_VseTipiPolzovatelei.read(auth, (data) => {
			if (data.length > 0) {
				dispatch({ type: 'ROLE', payload: data });
			}
		}, 'model', 's-id=ASC');
		RefreshAkkaunti();
		auth.openSocket("/ws/service", "service", function (type, payload) {
			if (type === "reload") {
				window.location.href = window.location.href;
			}
			switch (type) {
				case "siteaccess":
					dispatch({ type: "SITE_ACCESS", payload: payload });
					break;
				case "role":
					dispatch({ type: 'ROLE-UPDATE', payload: [payload] })
					break;
				case "status":
					publish(`service.${type}.${uuid}`, [payload]);
					dispatch({ type: 'STATUS-UPDATE', payload: [payload] })
					break;
				case "notify":
					publish(`service.${type}.${uuid}`, [payload]);
					dispatch({ type: 'NOTIFY-UPDATE', payload: [payload] })
					break;
				case "predlozhenierukiiserdtsa":
					dispatch(REDUX_Pari.actions.updateArray([payload]));
					break;
				case "polozhitelniiotvetnapredlozhenierukiiserdtsa":
					dispatch(REDUX_Pari.actions.updateArray([payload]));
					break;
				case "AkkauntiPolzovatelei":
					dispatch(REDUX_AkkauntiPolzovatelei.actions.updateArray([payload]));
					break;
				case "NeedUpdateAkkauntPolzovatelya":
					RefreshAkkaunti();
					break;
				default:
					publish("service." + type, payload);
					break;
			}
		});
		GETWITH(auth, '/api/query/InterfeisiInfrastrukturnikhStatusov', [
			QueryDetail("model"),
			QueryOrder("status.DataPoslednegoIzmeneniya", "DESC"),
			QueryParam("w-TipNovayaInfa", "true"),
			QueryParam("w-status.Arkhiv", "false")
		], ({ data }) => {
			dispatch({ type: 'STATUS', payload: data })
		}, errorCatch);
		GETWITH(auth, '/api/query/InfrastrukturnieUvedomleniya', [
			QueryDetail("model"),
			QueryOrder("Data", "DESC"),
			QueryParam("w-eqOrNu-Prochitano", "false"),
		], ({ data }) => {
			dispatch({ type: 'NOTIFY', payload: data })
		}, errorCatch);
		CRUDE_Pari.read(auth, (data) => {
			if (data.length > 0) {
				dispatch(REDUX_Pari.actions.setArray(data?.filter(item => !item.dokumentVikhodaID)));
			}
		}, 'model', 's-id=ASC');
	};
	const _unsubscribe = () => {
		auth.closeSocket("service");
	};

	const _RefreshAkkaunti = () => {
		READWITH(auth, "AkkauntiPolzovatelei", [
			QueryOrder("akkaunt.akkauntType.ID", "ASC"),
			QueryDetail("model")
		], ({ data }) => {
			if (data) {
				dispatch(REDUX_AkkauntiPolzovatelei.actions.updateArray(data));
			}
		}, errorCatch);
	};
	var RefreshAkkaunti = _.throttle(_RefreshAkkaunti, 3000, { 'trailing': false });

	const logout = () => {
		auth.logout(() => {
			navigate('/app');
		});
	}
	const logoutall = (e) => {
		e.stopPropagation();
		e.preventDefault();
		confirm({
			title: 'Вы действительно хотите выйти на всех устройствах?',
			icon: <Icofont icon="logout" style={{ color: "red" }} />,
			content: <span style={{ fontSize: "12px" }}>На всех подключенных устройствах будет отменена текущая сессия аутентификации и потребуется повторно ввести логин и пароль для породолжения работы</span>,
			okText: 'Выйти',
			cancelText: 'Отмена',
			onOk() {
				auth.logoutall(() => {
					navigate('/');
				});
			},
			onCancel() {
			},
		})
	}

	//------------------------------------------------------------------

	const [layoutWidth, setLayoutWidth] = useLayoutWidthContext();
	const isMobile = useIsMobileContext();
	const isDesktopOrLaptop = useIsDesktopOrLaptopContext();

	return (
		<TranslateContext.Provider value={t}>
			<MetaContext.Provider value={meta}>
				<UserContext.Provider value={user}>
					<UserConfigContext.Provider value={[userConfig, setUserConfig]}>
						<LanguageContext.Provider value={[language, setLanguage]}>
							<LangSwitchContext.Provider value={<LangSwitch userConfig={userConfig} />}>
								<Layout>
									<FedHeader user={user} logout={logout} logoutall={logoutall} layout={layout} fullwidth={fullwidth}>
										<MenuOne menu={menu(status, notify)} />
									</FedHeader>
									<Content style={{ padding: '6px' }}>
										<MenuLevelOneContext.Provider value={menu(status, notify)}>
											{(!siteAccess || siteAccess == "allow") && <Routes>
												{defaultRoute(menu(status, notify), role_by_id)}
												{menu(status, notify).map((e, idx) => {
													if (e.component && access(e, role_by_id)) {
														return <Route key={e.uuid} path={(e.uuid !== "*") ? e.uuid + "/*" : "*"} element={
															<BreadcrumbsProvider value={{
																uuid: e?.uuid,
																name: e?.name,
																color: e?.color,
																role: e?.role,
																hidden: e.hidden
															}}>
																{e.component({})}
															</BreadcrumbsProvider>} />
													}
												})}
											</Routes>}
											{(siteAccess == "deny") &&
												<Layout style={(!isDesktopOrLaptop) ? {} : { width: layoutWidth, margin: "0 auto" }}>
													<Layout.Content style={{ minHeight: 600, padding: "0px 0px 0px 0px" }}>
														<Routes>
															<Route exact path="admin" element={<AdminMainResourceLocks {...props} auth={auth} />} />
															<Route exact path="admin/main/resource-locks" element={<AdminMainResourceLocks {...props} auth={auth} />} />
															<Route path="*" element={<SiteAccessDeny {...props} auth={auth} />} />
														</Routes>
													</Layout.Content>
												</Layout>}
										</MenuLevelOneContext.Provider>
									</Content>
									<Footer style={{ textAlign: 'center', fontSize: "12px" }}>
										Общероссийская физкультурно-спортивная общественная организация "Всероссийская федерация социальных танцев"
									</Footer>
								</Layout>
							</LangSwitchContext.Provider>
						</LanguageContext.Provider>
					</UserConfigContext.Provider>
				</UserContext.Provider>
			</MetaContext.Provider>
		</TranslateContext.Provider>
	);
};

export default Home;